import I18n from 'I18n';
import { CUSTOM } from 'reporting-data/constants/chartTypes';
import { getChartTypesForReportChartTypeTransforms, getIsReportValidForChartTypeTransformation } from 'reporting-data/report/report-transformations/chartTypeTransformations';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { RelationalReportVisualTypeOptions } from 'reporting-ui-components/constants/relationalReportVisualTypeOptions';
import { EVENTS } from 'reporting-ui-components/lib/events';
import { getUsageTracker } from 'reporting-ui-components/monitoring/usageTracker';
import { RESTRICTED_RELATIONAL_REPORT_VISUAL_TYPES } from '../../lib/shared-utils';
export const getChartTypeOptions = (report, scopes, excludedChartTypes) => {
  if (!getIsReportValidForChartTypeTransformation(report)) {
    return [];
  }
  const chartTypeList = getChartTypesForReportChartTypeTransforms(report, scopes, excludedChartTypes);
  const isJourney = isJourneyReport(report);
  return chartTypeList.filter(type => type !== CUSTOM).map(type => {
    const textKey = isJourney ? `report-customization-components.customization-components.chartTypeToggle.journeyOptions.${type}` : `report-customization-components.customization-components.chartTypeToggle.options.${type}`;
    return {
      text: I18n.text(textKey),
      value: type
    };
  }).sort((option1, option2) => option1.text.localeCompare(option2.text));
};
export const getRelationalReportVisualTypeOptions = (excludedVisualTypes = []) => {
  const visualTypeOptionsMap = RelationalReportVisualTypeOptions.map(option => ({
    value: option.type,
    text: I18n.text(option.labelI18n)
  }));
  const allExcludedTypes = [...RESTRICTED_RELATIONAL_REPORT_VISUAL_TYPES, ...excludedVisualTypes];
  const filteredOptions = visualTypeOptionsMap.filter(option => !allExcludedTypes.includes(option.value));
  return filteredOptions;
};
export const trackChartTypeChange = (value, trackingAssetType, trackingApplicationName, trackingScreenName) => {
  const usageTracker = getUsageTracker();
  usageTracker.track(EVENTS.changeChartType, {
    action: 'change-chart-type',
    assetType: trackingAssetType || 'report',
    applicationName: trackingApplicationName,
    whereScreen: trackingScreenName,
    reportType: value
  });
};